import React, { ChangeEvent, FC } from 'react';
import { ReactComponent as MagnifyingGlass } from 'src/assets/images/magnifying-glass.svg';
import styled from 'styled-components';
import { Black, Grey, White } from '../styles/colours';
import { Regular } from '../styles/fonts';

export const StyledInput = styled.input`
  font-family: ${Regular};
  background: ${White};
  color: ${Black};
  border: none;
  font-size: 1rem;
  margin-left: 1rem;
  margin-top: 0.2rem;
  width: 15rem;
  outline: none;
  ::placeholder {
    opacity: 0.6;
  }
`;

export const SearchContainer = styled.div`
  display: inline-flex;
  border: 1px solid ${Grey};
  border-radius: 0.25rem;
  padding: 0.25rem;
`;

export const MagnifyingGlassContainer = styled.button`
  margin: 0.5rem;
  line-height: 10px;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
`;

export const StyledForm = styled.form`
  margin: 0.5rem;
`;

export const SearchInputForm: FC<{
  name: string;
  onSubmit: (e: ChangeEvent<HTMLFormElement>) => void;
  placeholder?: string;
}> = ({ onSubmit, name, placeholder }) => {
  return (
    <StyledForm onSubmit={onSubmit} data-type={`${name}-form`}>
      <SearchContainer>
        <StyledInput
          data-type={`${name}-input`}
          name={name}
          placeholder={placeholder}
        />
        <MagnifyingGlassContainer data-type="button" type="submit">
          <MagnifyingGlass />
        </MagnifyingGlassContainer>
      </SearchContainer>
    </StyledForm>
  );
};
